/**
 * The pre-shared token the backend expects in `X-API-TOKEN` for pre-authentication.
 *
 * Read from the environment rather than threaded through component props and
 * client configs: it is a deployment constant, not per-user state, and every
 * backend call needs it — so the single `authFetch` choke point can fetch it
 * itself.
 */
import { readEnv } from '../env';

/**
 * Throws instead of falling back to a placeholder: a missing token would
 * otherwise reach the backend and come back as unexplained 401s.
 */
export function getApiToken(): string {
  const token = readEnv('VITE_API_TOKEN');
  if (!token) {
    throw new Error('VITE_API_TOKEN is not configured — the backend rejects requests without it.');
  }
  return token;
}
